import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as DOMPurify from 'dompurify'; // works with older TS versions

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private readonly sanitized: DomSanitizer) { }
  transform(value: string): SafeHtml {
    const clean = DOMPurify.sanitize(value);
    return this.sanitized.bypassSecurityTrustHtml(clean);
  }
}
